/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { LoginDto } from '../models';
import { LoginResponseDto } from '../models';
import { RegisterDto } from '../models';
import { RegisterResponseDto } from '../models';
import { RequestResetPasswordDto } from '../models';
import { RequestResetPasswordResponseDto } from '../models';
import { SupportDTO } from '../models';
/**
 * UserNotAuthenticatedApi - axios parameter creator
 * @export
 */
export const UserNotAuthenticatedApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Verifies the email existence in the system
     * @param {string} email Email address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appControllerEmailVerification: async (
      email: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      if (email === null || email === undefined) {
        throw new RequiredError(
          'email',
          'Required parameter email was null or undefined when calling appControllerEmailVerification.'
        );
      }
      const localVarPath = `/email-verification/{email}`.replace(
        `{${'email'}}`,
        encodeURIComponent(String(email))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Authenticates a user with the provided credentials (username and password)
     * @param {LoginDto} body Login data containing the username and password for authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appControllerLogin: async (
      body: LoginDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling appControllerLogin.'
        );
      }
      const localVarPath = `/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Registers a new user and generates authentication tokens
     * @param {RegisterDto} body The data needed to register a new user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appControllerRegister: async (
      body: RegisterDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling appControllerRegister.'
        );
      }
      const localVarPath = `/register`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Requests a password reset for a user
     * @param {RequestResetPasswordDto} body Data transfer object containing the username for password reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appControllerRequestResetPassword: async (
      body: RequestResetPasswordDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling appControllerRequestResetPassword.'
        );
      }
      const localVarPath = `/password-reset-request`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Send support email (retrocompatible)
     * @param {SupportDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appControllerSendSupportEmail: async (
      body: SupportDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling appControllerSendSupportEmail.'
        );
      }
      const localVarPath = `/support-email`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserNotAuthenticatedApi - functional programming interface
 * @export
 */
export const UserNotAuthenticatedApiFp = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Verifies the email existence in the system
     * @param {string} email Email address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerEmailVerification(
      email: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<any>>
    > {
      const localVarAxiosArgs = await UserNotAuthenticatedApiAxiosParamCreator(
        configuration
      ).appControllerEmailVerification(email, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Authenticates a user with the provided credentials (username and password)
     * @param {LoginDto} body Login data containing the username and password for authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerLogin(
      body: LoginDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<LoginResponseDto>>
    > {
      const localVarAxiosArgs = await UserNotAuthenticatedApiAxiosParamCreator(
        configuration
      ).appControllerLogin(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Registers a new user and generates authentication tokens
     * @param {RegisterDto} body The data needed to register a new user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerRegister(
      body: RegisterDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<RegisterResponseDto>>
    > {
      const localVarAxiosArgs = await UserNotAuthenticatedApiAxiosParamCreator(
        configuration
      ).appControllerRegister(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Requests a password reset for a user
     * @param {RequestResetPasswordDto} body Data transfer object containing the username for password reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerRequestResetPassword(
      body: RequestResetPasswordDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<RequestResetPasswordResponseDto>>
    > {
      const localVarAxiosArgs = await UserNotAuthenticatedApiAxiosParamCreator(
        configuration
      ).appControllerRequestResetPassword(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Send support email (retrocompatible)
     * @param {SupportDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerSendSupportEmail(
      body: SupportDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await UserNotAuthenticatedApiAxiosParamCreator(
        configuration
      ).appControllerSendSupportEmail(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * UserNotAuthenticatedApi - factory interface
 * @export
 */
export const UserNotAuthenticatedApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Verifies the email existence in the system
     * @param {string} email Email address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerEmailVerification(
      email: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<any>> {
      return UserNotAuthenticatedApiFp(configuration)
        .appControllerEmailVerification(email, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Authenticates a user with the provided credentials (username and password)
     * @param {LoginDto} body Login data containing the username and password for authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerLogin(
      body: LoginDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<LoginResponseDto>> {
      return UserNotAuthenticatedApiFp(configuration)
        .appControllerLogin(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Registers a new user and generates authentication tokens
     * @param {RegisterDto} body The data needed to register a new user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerRegister(
      body: RegisterDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<RegisterResponseDto>> {
      return UserNotAuthenticatedApiFp(configuration)
        .appControllerRegister(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Requests a password reset for a user
     * @param {RequestResetPasswordDto} body Data transfer object containing the username for password reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerRequestResetPassword(
      body: RequestResetPasswordDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<RequestResetPasswordResponseDto>> {
      return UserNotAuthenticatedApiFp(configuration)
        .appControllerRequestResetPassword(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Send support email (retrocompatible)
     * @param {SupportDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerSendSupportEmail(
      body: SupportDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return UserNotAuthenticatedApiFp(configuration)
        .appControllerSendSupportEmail(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserNotAuthenticatedApi - object-oriented interface
 * @export
 * @class UserNotAuthenticatedApi
 * @extends {BaseAPI}
 */
export class UserNotAuthenticatedApi extends BaseAPI {
  /**
   *
   * @summary Verifies the email existence in the system
   * @param {string} email Email address
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserNotAuthenticatedApi
   */
  public async appControllerEmailVerification(
    email: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return UserNotAuthenticatedApiFp(this.configuration)
      .appControllerEmailVerification(email, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Authenticates a user with the provided credentials (username and password)
   * @param {LoginDto} body Login data containing the username and password for authentication
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserNotAuthenticatedApi
   */
  public async appControllerLogin(
    body: LoginDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<LoginResponseDto>> {
    return UserNotAuthenticatedApiFp(this.configuration)
      .appControllerLogin(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Registers a new user and generates authentication tokens
   * @param {RegisterDto} body The data needed to register a new user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserNotAuthenticatedApi
   */
  public async appControllerRegister(
    body: RegisterDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<RegisterResponseDto>> {
    return UserNotAuthenticatedApiFp(this.configuration)
      .appControllerRegister(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Requests a password reset for a user
   * @param {RequestResetPasswordDto} body Data transfer object containing the username for password reset
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserNotAuthenticatedApi
   */
  public async appControllerRequestResetPassword(
    body: RequestResetPasswordDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<RequestResetPasswordResponseDto>> {
    return UserNotAuthenticatedApiFp(this.configuration)
      .appControllerRequestResetPassword(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Send support email (retrocompatible)
   * @param {SupportDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserNotAuthenticatedApi
   */
  public async appControllerSendSupportEmail(
    body: SupportDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return UserNotAuthenticatedApiFp(this.configuration)
      .appControllerSendSupportEmail(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
